import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { SyncOutlined } from "@ant-design/icons";
import { removeCsrfCookie } from "@app/lib";
import { Alert, Button, Result } from "antd";
import { useRouter } from "next/router";
import { useIlmoContext, useTranslation } from ".";
export function ErrorResult({ error }) {
    const { t } = useTranslation("error");
    const { resetUrqlClient } = useIlmoContext();
    const router = useRouter();
    const message = error?.graphQLErrors?.[0]
        ?.message;
    const handleCsrfRefresh = useCallback(() => {
        removeCsrfCookie();
        resetUrqlClient();
        router.reload();
    }, [resetUrqlClient, router]);
    if (message?.includes("CSRF")) {
        return (_jsx(Result, { extra: _jsx(Button, { "data-cy": "error-csrf-refresh", icon: _jsx(SyncOutlined, {}), type: "primary", onClick: handleCsrfRefresh, children: t("refresh") }), status: "403", subTitle: t("csrfError"), title: t("ErrorResult.invalidCsrfToken") }));
    }
    return (_jsx(Result, { status: "error", subTitle: t("unknownError"), title: _jsx(_Fragment, { children: t("ErrorResult.unexpectedError") }), children: _jsx(Alert, { message: error.message, type: "error" }) }));
}
//# sourceMappingURL=ErrorResult.js.map